<ng-template #registruMonteFatari let-modal="close">
  <div class="modal-header">
    <h3 class="modal-title">
      Registru de Monte și Fătări
    </h3>

    <button
      type="button"
      class="close"
      aria-hidden="true"
      (click)="modal('Cross click')"
    >
      ×
    </button>
  </div>

  <div class="modal-body">
    <div class="container-fluid">

      <form [formGroup]="form">
        <div class="row">
          <div class="col-12">
            <label>
              Exploatația:
            </label>

            <br>
            <span class="h5">{{ numeExploatatie }} - {{ codExploatatie }}</span>
          </div>
        </div>

        <div
          *ngIf="loadingSpinner"
          class="spinner-border text-info avatar-lg"
          role="status"
        ></div>

        <div
          *ngIf="!loadingSpinner"
          class="row mt-3"
        >
          <div class="col-12">
            <button
              class="btn btn-success"
              (click)="onSubmitted()"
            >
              Descarcă
            </button>
          </div>
        </div>
      </form>

    </div>
  </div>
</ng-template>
